

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'celsiusTemperature',
  standalone: true
})
export class CelsiusTemperaturePipe implements PipeTransform {
  transform(value: number | string | null | undefined): string {
    let num = Number(value);
    if (value === null || value === undefined || value === '' || isNaN(num)) {
      return '-';
    }

    num = Math.round((num + Number.EPSILON) * 100) / 100;
    return `${num} °C`;
  }
}